import { render, staticRenderFns } from "./MonitoringsNew.vue?vue&type=template&id=3633bbe2&scoped=true&"
import script from "./MonitoringsNew.vue?vue&type=script&lang=js&"
export * from "./MonitoringsNew.vue?vue&type=script&lang=js&"
import style0 from "./MonitoringsNew.vue?vue&type=style&index=0&lang=css&"
import style1 from "./MonitoringsNew.vue?vue&type=style&index=1&id=3633bbe2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3633bbe2",
  null
  
)

component.options.__file = "MonitoringsNew.vue"
export default component.exports